import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    autofocus: { type: Boolean, default: false },
    token: String,
  };

  connect() {
    this.focusStepContent();
  }

  tokenValueChanged() {
    this.focusStepContent();
  }

  focusStepContent() {
    if (!this.autofocusValue) return;

    requestAnimationFrame(() => {
      const focusTarget = this.element.querySelector(
        "[data-check-in-focus-target]",
      );
      if (!focusTarget) return;

      focusTarget.focus({ preventScroll: true });
    });
  }
}
